import { UserViewMode } from '@pubstack/common/src/rolesAndFeatures'
import { AdminCSVUser } from '@pubstack/common/src/user'
import { MutationToasts, useLazyQuery, useMutation } from '../api-client'

export const ADMIN_USERS_QUERY_KEYS = ['admin', 'users']

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useAdminUsersCSV = () => {
  return useLazyQuery<AdminCSVUser[]>({
    url: '/admin/users/csv',
    keys: [...ADMIN_USERS_QUERY_KEYS, 'csv'],
  })
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useToggleUserView = (toasts: MutationToasts = {}) => {
  return useMutation<{ view: UserViewMode | undefined }>({
    method: 'post',
    url: '/admin/users/toggle-view',
    collectionKeys: ADMIN_USERS_QUERY_KEYS,
    ...toasts,
  })
}
